import { FC } from "react";
import { Box } from "@mui/material";
import { useUpdateLearnerPlanStatus } from "@/api/services/main/learner";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { LearnerPlanStatusSelect } from "@/features/learner/components/learner-list/LearnerPlanStatusSelect";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";

type TLearnerPlanStatusCellProps = {
  learnerId: number;
  value: string;
  options: { value: string; label: string }[];
  isDisabledHandling?: boolean;
};

export const LearnerPlanStatusCell: FC<TLearnerPlanStatusCellProps> = ({
  learnerId,
  value,
  options,
  isDisabledHandling,
}) => {
  const { mutate, isPending } = useUpdateLearnerPlanStatus();

  const handleChange = (newValue: string) => {
    if (newValue === value) return;
    mutate(
      { learnerId, planStatus: newValue },
      {
        onSuccess: () => {
          toast.success(API_SUCCESS_MESSAGE);
        },
        onError: (error) => {
          showError(error);
        },
      }
    );
  };

  return (
    <Box onClick={(e) => e.stopPropagation()} sx={{ display: "inline-flex" }}>
      <LearnerPlanStatusSelect
        value={value}
        options={options}
        onChange={handleChange}
        isLoading={isPending}
        disabled={isDisabledHandling}
      />
    </Box>
  );
};
